import { render } from "./ConsultarClientes.vue?vue&type=template&id=5194983f&scoped=true"
import script from "./ConsultarClientes.vue?vue&type=script&lang=js"
export * from "./ConsultarClientes.vue?vue&type=script&lang=js"

import "./ConsultarClientes.vue?vue&type=style&index=0&id=5194983f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5194983f"]])

export default __exports__